"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenizedServiceConnection = void 0;
var axios_1 = require("axios");
var __1 = require("..");
var TokenizedServiceConnection = /** @class */ (function () {
    function TokenizedServiceConnection(obtainTokenMethodName, obtainTokenMethodType, needsSession, invalidTokenReturnCode, urlAndTokenObtainer, connection, errorCallback) {
        var _this = this;
        this.isEnabled = function (enabledCallback, disabledCallback) {
            var check = function () {
                if (!_this.url || !_this.token) {
                    disabledCallback();
                }
                else {
                    enabledCallback(_this.url, _this.token);
                }
            };
            if (!_this.url || !_this.token) {
                _this.obtainToken(check);
                return;
            }
            else {
                enabledCallback(_this.url, _this.token);
            }
        };
        this.callTokenizedApi = function (methodName, data, successCallback, unsuccessCallback) {
            _this.isEnabled(function (url, token) {
                data.token = token;
                TokenizedServiceConnection.call(url, methodName, data, successCallback, function (result) {
                    if (result.ReturnCodeString === _this.invalidTokenReturnCode) {
                        _this.obtainToken(function () {
                            _this.callTokenizedApi(methodName, data, successCallback, unsuccessCallback);
                        });
                        return;
                    }
                    if (unsuccessCallback) {
                        unsuccessCallback(result);
                    }
                    else {
                        if (!!_this.generalErrorCallback) {
                            var error = new Error('Unhandled tokenized service connection return code ' + result.ReturnCodeString + '.\nDescription: ' + result.Description);
                            _this.generalErrorCallback(error);
                        }
                    }
                }, function (error) {
                    if (!!_this.generalErrorCallback) {
                        var err = new Error('Unhandled tokenized service connection communication error: ' + JSON.stringify(error));
                        _this.generalErrorCallback(err);
                    }
                });
            }, function () {
                if (unsuccessCallback) {
                    unsuccessCallback(null);
                }
            });
        };
        this.obtainToken = function (callback) {
            if (!_this.isActive) {
                _this.url = null;
                _this.token = null;
                callback();
                return;
            }
            var successClb = function (result) {
                var obtainedResult = _this.urlAndTokenObtainer(result);
                if (!obtainedResult.url || !obtainedResult.token) {
                    _this.url = null;
                    _this.token = null;
                    _this.isActive = false;
                    callback();
                }
                else {
                    _this.url = obtainedResult.url;
                    _this.token = obtainedResult.token;
                    _this.isActive = true;
                    callback();
                }
            };
            var unsuccessClb = function () {
                _this.url = null;
                _this.token = null;
                _this.isActive = false;
                callback();
            };
            if (_this.needsSession) {
                _this.connection.callMethod(_this.obtainTokenMethodName, {}, successClb, unsuccessClb, _this.obtainTokenMethodType);
            }
            else {
                _this.connection.callWithoutSession(_this.obtainTokenMethodName, null, successClb, unsuccessClb, null, _this.obtainTokenMethodType);
            }
        };
        this.obtainTokenMethodName = obtainTokenMethodName;
        this.obtainTokenMethodType = obtainTokenMethodType;
        this.needsSession = needsSession;
        this.invalidTokenReturnCode = invalidTokenReturnCode;
        this.urlAndTokenObtainer = urlAndTokenObtainer;
        this.connection = connection;
        this.generalErrorCallback = errorCallback || null;
        this.url = null;
        this.token = null;
        this.isActive = true;
    }
    TokenizedServiceConnection.call = function (serviceUrl, methodName, data, successCallback, unsuccessCallback, errorCallback) {
        // We count on that we are in Admin/Subdirectory.
        var address = serviceUrl + '/' + methodName;
        axios_1.default.post(address, data)
            .then(function (response) {
            if (response.status === 200) {
                if (response.data.ReturnCodeString === 'Success') {
                    successCallback(response.data);
                }
                else {
                    unsuccessCallback(response.data);
                }
            }
            else {
                errorCallback(new __1.HttpRequestError(response.status, response.statusText));
            }
        })
            .catch(function (error) {
            if (error.response) {
                errorCallback(new __1.HttpRequestError(error.response.status, error.response.statusText));
                return;
            }
            errorCallback(error);
        });
    };
    return TokenizedServiceConnection;
}());
exports.TokenizedServiceConnection = TokenizedServiceConnection;
